/**
 * Phase 10D: Banner when user is offline.
 */
import React, { useState, useEffect } from 'react';
import { Alert, AlertTitle, Button } from '@mui/material';
import { WifiOff } from '@mui/icons-material';
import { relativeTime } from '../utils/renewalHelpers';
import t from '../utils/renewalsTranslations';

const locale = (typeof window !== 'undefined' && localStorage.getItem('locale')) || 'en';

export default function OfflineBanner() {
  const [isOnline, setIsOnline] = useState(typeof navigator !== 'undefined' ? navigator.onLine : true);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  if (isOnline) return null;

  const cachedTime = sessionStorage.getItem('renewals_cached_at');
  const message = cachedTime
    ? ("You're offline. Showing cached data from " + (relativeTime(cachedTime, locale) || cachedTime))
    : "You're offline. Some data may be outdated.";

  return (
    <Alert severity="warning" icon={<WifiOff />} sx={{ borderRadius: 0 }} action={<Button color="inherit" size="small" disabled>Sync Now</Button>}>
      <AlertTitle>Offline</AlertTitle>
      {message}
    </Alert>
  );
}
